import { css } from '@compiled/react';
import { UniformSlot } from '@uniformdev/canvas-react';

import { wacToken } from '@/libraries/design/foundations';

const containerStyle = css({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
});

const titleStyle = css({
	margin: '0 0 16px 0',
	fontWeight: 'bold',
	fontSize: '1.5em',
});

const tableStyle = css({
	lineHeight: '1',
	fontFamily:
		'Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif',
	color: wacToken('color.extended.blue1000'),
	width: '100%',
	boxSizing: 'inherit',
	margin: '0',
	padding: '0',
	border: '0',
	fontSize: '100%',
	verticalAlign: 'baseline',
	borderCollapse: 'collapse',
	borderSpacing: '0',
	marginBlockEnd: '24px',
});

const headStyle = css({
	lineHeight: '1',
	fontFamily:
		'Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif',
	color: wacToken('color.extended.blue1000'),
	borderCollapse: 'collapse',
	borderSpacing: '0',
	boxSizing: 'inherit',
	margin: '0',
	padding: '0',
	border: '0',
	fontSize: '100%',
	verticalAlign: 'baseline',
	// eslint-disable-next-line local/ensure-wac-token-usage
	borderBottom: '2px solid #EBECF0',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& th': {
		padding: '10px 8px',
		textAlign: 'center',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& th:first-of-type': {
		textAlign: 'left',
	},
});

const bodyStyle = css({
	lineHeight: '1',
	fontFamily:
		'Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif',
	color: wacToken('color.extended.blue1000'),
	borderCollapse: 'collapse',
	borderSpacing: '0',
	boxSizing: 'inherit',
	margin: '0',
	padding: '0',
	border: '0',
	fontSize: '100%',
	verticalAlign: 'baseline',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& tr': {
		// eslint-disable-next-line local/ensure-wac-token-usage
		borderBottom: '2px solid #EBECF0',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& td': {
			padding: '10px 8px',
		},
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& tr:nth-child(odd)': {
		backgroundColor: wacToken('color.neutral.light200'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& tr:nth-child(even)': {
		backgroundColor: wacToken('color.neutral.light0'),
	},
});

export interface UniformDownloadTableProps {
	title: string;
}

const UniformDownloadTable = ({ title }: UniformDownloadTableProps) => {
	return (
		<div css={containerStyle}>
			<h3 css={titleStyle}>{title}</h3>
			<table css={tableStyle}>
				<thead css={headStyle}>
					<tr>
						<th className="h5">
							<strong>Version</strong>
						</th>
						<th className="h5">
							<strong>Size</strong>
						</th>
						<th className="h5">
							<strong>Build Date</strong>
						</th>
						<th className="h5">
							<strong>Format</strong>
						</th>
					</tr>
				</thead>
				<tbody css={bodyStyle}>
					<UniformSlot name="downloadrow" />
				</tbody>
			</table>
		</div>
	);
};

export default UniformDownloadTable;
